import { render } from "./ManageLiveClass.vue?vue&type=template&id=6dfda8aa&scoped=true"
import script from "./ManageLiveClass.vue?vue&type=script&lang=js"
export * from "./ManageLiveClass.vue?vue&type=script&lang=js"

import "./ManageLiveClass.vue?vue&type=style&index=0&id=6dfda8aa&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfda8aa"]])

export default __exports__